import { DEFAULT_MAP_BOUNDARIES } from '../components/maps/mapBoundaryConfig.mjs'

export const DEFAULT_RUNTIME_SETTINGS = Object.freeze({
  map: Object.freeze({
    boundaries: DEFAULT_MAP_BOUNDARIES,
    presentation: Object.freeze({ palette: 'blue', opacity: 0.78, showLabels: false }),
  }),
  localization: Object.freeze({ locale: 'en-RW', timezone: 'Africa/Kigali', dateFormat: 'dd/MM/yyyy' }),
})

export function mergeRuntimeSettings(settings) {
  return {
    ...DEFAULT_RUNTIME_SETTINGS,
    ...(settings || {}),
    map: {
      ...DEFAULT_RUNTIME_SETTINGS.map,
      ...(settings?.map || {}),
      boundaries: {
        ...DEFAULT_RUNTIME_SETTINGS.map.boundaries,
        ...(settings?.map?.boundaries || {}),
      },
      presentation: {
        ...DEFAULT_RUNTIME_SETTINGS.map.presentation,
        ...(settings?.map?.presentation || {}),
      },
    },
    localization: {
      ...DEFAULT_RUNTIME_SETTINGS.localization,
      ...(settings?.localization || {}),
    },
  }
}

export async function loadRuntimeSettings(runtimeRequest) {
  try {
    const result = await runtimeRequest()
    return { settings: mergeRuntimeSettings(result?.settings), loading: false, error: null }
  } catch {
    return {
      settings: mergeRuntimeSettings(),
      loading: false,
      error: 'Settings unavailable; safe defaults are active.',
    }
  }
}
